module.exports = "/static/assets/d903f979731e0aa1b305333c87957072.png";